// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as TicketingOrderRepoManager from "./repo/order/TicketingOrderRepoManager.bs.js";

function fetchOrder(order_crn, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return Curry._2(RepoInstance.fetchOrder, order_crn, country);
}

function fetchOrderFares(order_crn, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return Curry._2(RepoInstance.fetchOrderFareBreakup, order_crn, country);
}

export {
  fetchOrder ,
  fetchOrderFares ,
  
}
/* TicketingOrderRepoManager Not a pure module */
